import type { TFunction } from 'i18next';

export const ACTIVE_ORDER_STATUSES: string[] = ['PENDING', 'PAYMENT_REVIEW', 'CONFIRMED'];
export const PAST_ORDER_STATUSES: string[] = ['DONE', 'CANCELLED'];

/** Status badge fill; pair with `ORDER_STATUS_TEXT_COLORS` for the text on it. */
export const ORDER_STATUS_COLORS: Record<string, string> = {
  PENDING: 'var(--color-warning)',
  PAYMENT_REVIEW: 'var(--color-accent)',
  CONFIRMED: 'var(--color-success)',
  DONE: 'var(--color-success)',
  CANCELLED: 'var(--color-error)',
};

/** Contrast-safe text color for each `ORDER_STATUS_COLORS` fill. */
export const ORDER_STATUS_TEXT_COLORS: Record<string, string> = {
  PENDING: 'var(--color-on-warning)',
  PAYMENT_REVIEW: 'var(--color-on-accent)',
  CONFIRMED: 'var(--color-on-success)',
  DONE: 'var(--color-on-success)',
  CANCELLED: 'var(--color-on-error)',
};

export const ORDER_STATUS_FALLBACK_COLOR = 'var(--color-disabled)';
export const ORDER_STATUS_FALLBACK_TEXT_COLOR = 'var(--color-on-disabled)';

export const ORDER_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  PAYMENT_REVIEW: 'Payment Review',
  CONFIRMED: 'Confirmed',
  DONE: 'Completed',
  CANCELLED: 'Cancelled',
};

export function getOrderStatusLabel(status: string, t: TFunction): string {
  return t(`orderStatus.${status}`, {
    defaultValue: ORDER_STATUS_LABELS[status] ?? status,
  });
}
